<template>
  <div>
    <el-table :data="options" border style="width: 100%" height="250">
      <el-table-column fixed align="center" width="55" label="">
        <template slot-scope="scope">
          <el-radio v-model="value" :label="scope.row.groupId" :disabled="scope.row.disabled">&nbsp;</el-radio>
        </template>
      </el-table-column>

      <el-table-column fixed label="组织机构" align="center" width="190px">
        <template slot-scope="scope">
          <span>{{ scope.row.deptFullName }}</span>
        </template>
      </el-table-column>

      <el-table-column fixed label="归属商户类型" align="center" width="190px">
        <template slot-scope="scope">
          <span>{{ scope.row.orgCategory|searchOptions(deptCategory) }}</span>
        </template>
      </el-table-column>
      <el-table-column fixed prop="roleNames" label="角色" align="center" width="190px" />
      <el-table-column fixed label="最近登录时间" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.lastLoginTimestamp">{{ scope.row.lastLoginTimestamp|parseTime }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>

</template>

<script>
import { getOptions } from '@/api/commonality/type'
import notify from '@/mixin/notify'
export default {
  name: 'SwitchGroup',
  mixins: [notify],
  props: {
    options: {
      type: [Array],
      default: () => []
    }
  },
  data() {
    return {
      value: 0,
      // 部门种类
      deptCategory: []
    }
  },
  created() {
    this.initType()
  },
  methods: {
    initType() {
      const array = [
        { key: 'deptCategory', array: this.deptCategory }
      ]
      getOptions(array)
    },
    validateForm() {
      return new Promise((resolve, reject) => {
        if (this.value) {
          resolve(this.value)
        } else {
          this.errorNotify('请选择想要切换的账号')
          resolve(false)
        }
      })
    },
    resetFrom() {
      this.value = 0
    }
  }
}
</script>

<style>
</style>
